import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page-header-job',
  templateUrl: './page-header-job.component.html',
  styleUrls: ['./page-header-job.component.scss']
})
export class PageHeaderJobComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))
  
  @Input()
  header = ''

  @Input()
  backgroundPath = ''

  @Input()
  height = 300

  @Input()
  isCurveGray = false

  @Input()
  isCurveWhite = false

  @Input()
  isAboutUs = false

  pageHeaderStyle = {}

  constructor() { }

  ngOnInit() {
    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `${this.height}px`,
    }
  }

}
